import { AppRegistry } from "react-native";

import App from "./App.js";

AppRegistry.registerComponent("AmpleCareMobile", () => App);

const rootTag = document.getElementById("root");

if (rootTag) {
  AppRegistry.runApplication("AmpleCareMobile", {
    rootTag,
  });
}

export default App;
